export default {
    functional: true,
    render(createElement, { props }) {
        const Item = require('./Item.js').default;
        const itemElements = props.items.map((item) => createElement(Item, {
            props: {
                item,
                ...props,
            },
        }));
        return itemElements;
    },
};
